<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableSimpleStorageServiceResourceAzureListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableSimpleStorageServiceResourceAzureVue = {};
export default {
  name: "TableSimpleStorageServiceResourceAzure",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      val: "",
      columns: [
        {
          title: this.$t("RAM.Azure.storageAccount.storageAccountName"),
          key: "name"
        },
        {
          title: this.$t("RAM.Azure.storageAccount.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.Azure.storageAccount.subscriptionName"),
          key: "subscriptionName"
        },
        {
          title: this.$t("RAM.Azure.storageAccount.subscriptionID"),
          key: "subscriptionId"
        },
        {
          title: this.$t("RAM.Azure.storageAccount.resourceGroup"),
          key: "resourceGroup"
        },
        {
          title: this.$t("RAM.Azure.storageAccount.performance"),
          key: "performance"
        },
        {
          title: this.$t("RAM.Azure.storageAccount.status"),
          key: "state"
        },
        {
          title: this.$t("RAM.Azure.storageAccount.duplicationAndRedundant"),
          key: "replication"
        },
        {
          title: this.$t("RAM.Azure.storageAccount.accountType"),
          key: "accountKind"
        }
      ],
      tableSimpleStorageServiceResourceAzureListData: []
    };
  },
  beforeCreate: function() {
    tableSimpleStorageServiceResourceAzureVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("storageAccountSearchID", function(val) {
      tableSimpleStorageServiceResourceAzureVue.name = val;
    });
    eventBus.$on("companyId", function(val) {
      tableSimpleStorageServiceResourceAzureVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableSimpleStorageServiceResourceAzureVue.getSimpleStorageServiceResourceAzureListData();
    },
    // 分页显示数据
    /****************************************************/
    getSimpleStorageServiceResourceAzureListData: function() {
      this.$api.resourceManagement
        .selectAzureStorageAccountsByPage({
          pageNum: this.current,
          pageSize: this.pageSize,
          name: tableSimpleStorageServiceResourceAzureVue.name,
          companyId: tableSimpleStorageServiceResourceAzureVue.companyId
        })
        .then(res => {
          this.tableSimpleStorageServiceResourceAzureListData =
            res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableSimpleStorageServiceResourceAzureVue.getSimpleStorageServiceResourceAzureListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSimpleStorageServiceResourceAzureVue.getSimpleStorageServiceResourceAzureListData();
    },
    // 销毁storageAccountSearchID
    beforeDestroy: function() {
      eventBus.$off("storageAccountSearchID");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/s3/TableSimpleStorageServiceResourceAzure.vue